import { type PropType, type Component } from 'vue';
import { UiIconAttention } from '../../icons';

export interface AlertProps {
    icon?: Component;
    text?: string;
    color?: string;
    outlined?: boolean;
    bgColor?: string;
    borderColor?: string;
}

export const alertProps = {
    icon: {
        type: [Object, Function] as PropType<AlertProps['icon']>,
        default: () => UiIconAttention,
        required: false,
    },
    text: {
        type: String as PropType<AlertProps['text']>,
        default: undefined,
        required: false,
    },
    color: {
        type: String as PropType<AlertProps['color']>,
        default: undefined,
        required: false,
    },
    outlined: {
        type: Boolean as PropType<AlertProps['outlined']>,
        default: undefined,
        required: false,
    },
    bgColor: {
        type: String as PropType<AlertProps['bgColor']>,
        default: undefined,
        required: false,
    },
    borderColor: {
        type: String as PropType<AlertProps['borderColor']>,
        default: undefined,
        required: false,
    },
};
